var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metrics__rating general"},[_c('CommonTitle',{attrs:{"options":_vm.options_title}}),_c('CommonTable',{attrs:{"options":_vm.options_table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }